import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-kanban-reset-pin',
  templateUrl: './modal-kanban-reset-pin.component.html',
  styles: []
})
export class ModalKanbanResetPinComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
